import type { HttpInterceptorFn } from '@angular/common/http';

/**
 * staff-web 의 모든 요청에 `credentials: 'include'` (Angular `withCredentials: true`) 강제.
 *
 * refresh 쿠키(path `/staff/auth`)는 `/staff/auth/*` 호출에만 실려도 충분하지만, schoolbell-e-staff-web 의 쿠키 세션도 이 인터셉터를 쓰므로 전역 강제를 유지한다. 같은 origin인
 * 경우에도 명시 권장 — 로컬 개발에서 API 가 별 host일 때 동일하게 동작한다.
 */
export const staffCredentialsInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.withCredentials) return next(req);
  return next(req.clone({ withCredentials: true }));
};
